import { SerializedStyles } from '@emotion/react';
import {
  createContext,
  Dispatch,
  MutableRefObject,
  PropsWithChildren,
  Ref,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';

const SpotlightMangerContext = createContext<SpotlightContext>({
  targets: null,
  setCurrent: null,
  current: null
});

export function useSpotlightManager(): SpotlightContext {
  return useContext(SpotlightMangerContext);
}

export const SpotlightManagerProvider = (props: PropsWithChildren) => {
  const { children } = props;
  const targets = useMemo(() => new Map(), []);
  const [current, setCurrent] = useState<Ref<HTMLDivElement | null>>(null);

  return (
    <SpotlightMangerContext.Provider value={{ targets, current, setCurrent }}>
      {children}
    </SpotlightMangerContext.Provider>
  );
};

export type SpotlightContext = {
  targets: Map<string, MutableRefObject<HTMLDivElement | null>> | null;
  current: Ref<HTMLDivElement | null>;
  setCurrent: Dispatch<SetStateAction<Ref<HTMLDivElement | null>>> | null;
};

export type SpotlightTargetProps = {
  name: string;
  pulseSize?: number;
  speed?: 'slow' | 'fast';
  style?: SerializedStyles;
};
